class DashboardUniqueUsersController  {
    constructor(createAutoQuery, $session, $scope) {
        let $ctrl = this;
        let options = {
            url: 'QueryUniqueVisitors.json',
            criteria: {
                dateRange: $ctrl.date,
                startDate: $ctrl.start,
                endDate: $ctrl.end
            },
            autoLoad: true
        };
        $ctrl.query = createAutoQuery(options);
        $ctrl.$session = $session;
        $scope.$watch("$ctrl.date", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.start", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.end", function () {
            $ctrl.reload();
        });
    }
    reload() {
        this.query.criteria.dateRange = this.date;
        this.query.criteria.startDate = this.start;
        this.query.criteria.endDate = this.end;
        this.query.load(true);
    }
}

class DashboardUniqueUsers{
    constructor(){
        this.bindings= {
            date: '@',
            start: '@',
            end: '@'
        };
        this.controller = DashboardUniqueUsersController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-unique-users.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardUniqueUsers', new DashboardUniqueUsers());

export default DashboardUniqueUsers